import { AlertCircleIcon } from "lucide-react";
import React from "react";

function Unavailable() {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <AlertCircleIcon size={40} />
      <div className="pt-3 text-3xl font-bold">Service Unavailable</div>

      <div className="text-center text-sm">
        Sorry this service is currently unavailable <br /> please check again
        later
      </div>
    </div>
  );
}

export default Unavailable;
